import { Component } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { ObjectAction } from 'src/modules/sm-base/shared/object-action.model';
import { DocumentHandlerMainComponent } from '../document-handler-main/document-handler-main.component';
import { Utils } from 'src/modules/utils/shared/utils';

@Component({
    selector: 'app-text-tools',
    templateUrl: './text-tools.component.html',
    styleUrls: ['./text-tools.component.scss']
  })
export class TextToolsComponent extends ComponentView {

    text = "";
    actionButtons: ObjectAction[];

    async initParams(): Promise<boolean> {
        return Promise.resolve(true);
    }

    textChanged(): void {
        this.actionButtons = DocumentHandlerMainComponent.instance?.getContextMenuActions().filter(a => a.isUsable(this.text));
    }

    async run(button: ObjectAction): Promise<void> {
        this.text = Utils.stringDef(await button.perform(this.text), this.text);
    }

}
